"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useProductPackageContentServiceCall;

var _useServiceCall = _interopRequireDefault(require("@sprinx/react-api-client/useServiceCall"));

var _useDefaults = _interopRequireDefault(require("@sprinx/react-hooks/useDefaults"));

var _useResolveServiceActionName = _interopRequireDefault(require("@sprinx/react-api-client/useResolveServiceActionName"));

function useProductPackageContentServiceCall(options) {
  // const { clientCode, serviceNames } = useOrdersContext();
  var serviceName = (0, _useResolveServiceActionName.default)(null, 'v1.productContent.packageContent'
  /* , serviceNames */
  );
  return (0, _useServiceCall.default)((0, _useDefaults.default)(options, {
    clientCode: 'api',
    returnOnlyAction: true
  }), function (client, params) {
    return client.call(serviceName, params, {
      method: 'get',
      mockAction: 'getPackageContent'
    });
  });
}